module.exports = __webpack_public_path__ + "static/media/people.559e82cf.svg";